import chroma from "chroma-js";
import lodash from "lodash";

export default {
  install(Vue) {
    Vue.prototype.$Color = function() {
      const veutify = this.$vuetify;

      const darkText = "darkText";
      const brightText = "brightText";

      const colorFor = function({ color, saturation }) {
        let darken = saturation / 10;

        let veutifyColor = lodash.get(veutify.theme.themes.light, color);
        if (veutifyColor.base) {
          veutifyColor = veutifyColor.base;
        }

        let chromaColor = chroma(veutifyColor);
        chromaColor = chromaColor.darken(darken);

        return chromaColor.hex();
      };

      const colorText = function({ color, saturation }) {
        let chromaColor = chroma(colorFor({ color, saturation }));

        if (chromaColor.luminance() > 0.5) {
          return darkText;
        } else {
          return brightText;
        }
      };

      return {
        darkText: darkText,
        brightText: brightText,
        colorFor: colorFor,
        colorText: colorText,
      };
    };
  },
};
